/* eslint-disable max-len */
import { spawn, all } from 'redux-saga/effects';

import { sagas as sagaRegistry } from './loader';

export const prepSagas = (sagas = {}, options = []) =>
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  Object.values(sagas).map((saga) => spawn(saga, ...options));

export function createSaga(sagas = sagaRegistry) {
  return function* rootSaga(...options) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
    yield all(prepSagas(sagas, options));
  };
}
